import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store"; // Assure-toi que ./src/store/index.js existe

// Bootstrap 5 (CSS + JS optionnel)
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap"; // optionnel si tu utilises les composants JS
// Popper pour certains composants Bootstrap
import "@popperjs/core";

// Core-js si nécessaire pour polyfills
import "core-js/actual";

// Firebase v8 style (puisque tu utilises firebase/app et initializeApp)
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";

// Google Maps (Vue 3)
import VueGoogleMaps from "@fawmi/vue-google-maps";

// YouTube (Vue 3)
import VueYoutube from "vue3-youtube";
// Optionnel: Social share compatible Vue 3
// import Vue3SocialShare from 'vue3-social-share'
// import 'vue3-social-share/lib/index.css' // si la lib le requiert

const app = createApp(App);

app.use(router);
app.use(store);

//app.use(VueYoutube);
app.component("VueYoutube", VueYoutube);

app.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyACbBFnoaG5EVR7-IDGn8lsiTtPHxWQWB4",
    libraries: "places",
    v: "weekly", // version supportée (ou "quarterly")
    language: "en", // optionnel
    region: "EN", // optionnel
  },
});

// app.use(Vue3SocialShare)

const configOptions = {
  apiKey: "AIzaSyCjAO25m5q3tcutqboWO0RqAhZ-cl-XQvU",
  authDomain: "eifoany.firebaseapp.com",
  databaseURL: "https://eifoany.firebaseio.com",
  projectId: "eifoany",
  storageBucket: "eifoany.appspot.com",
  messagingSenderId: "461273703020",
  appId: "1:461273703020:web:90df54282f9f4ed7656e49",
  measurementId: "G-XMXNG8GCP4",
};

firebase.initializeApp(configOptions);


app.mount("#app");

// import { createApp, configureCompat } from "vue-compat";
// import App from "./App.vue";
// import router from "./router";

// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap"; // optionnel
// import "@popperjs/core"; // si nécessaire selon ton code
// import "bootstrap";
// import "bootstrap/dist/css/bootstrap.min.css";

// import store from "./store";

// import firebase from "firebase/app";
// import "firebase/firestore";

// import "core-js/actual";

// import * as VueGoogleMaps from "vue2-google-maps";
// import VueYoutube from "vue-youtube";
// import SocialSharing from "vue-social-sharing";

// import { CarouselPlugin } from "bootstrap-vue";

// configureCompat({ MODE: 2 });

// const app = createApp(App);

// app.use(router);
// app.use(store);

// app.use(SocialSharing);
// app.use(VueYoutube);
// app.use(VueGoogleMaps, {
//   load: {
//     key: "AIzaSyACbBFnoaG5EVR7-IDGn8lsiTtPHxWQWB4",
//     libraries: "places",
//   },
//   installComponents: true,
// });

// app.use(CarouselPlugin);

// // import Vue from "vue";
// // import App from "./App.vue";
// // import router from "./router";
// // import "bootstrap";
// // import "bootstrap/dist/css/bootstrap.min.css";
// // import { CarouselPlugin } from "bootstrap-vue";

// // import * as firebase from "firebase";
// // import { store } from "../store";
// // import firebase from "firebase/app";
// // import "firebase/app";
// // import "firebase/firestore";
// // import "core-js/actual";
// // import * as VueGoogleMaps from "vue2-google-maps";
// // import VueYoutube from "vue-youtube";
// // import SocialSharing from "vue-social-sharing";

// // Vue.use(SocialSharing);
// // Vue.use(VueYoutube);
// // Vue.use(VueGoogleMaps, {
// //   load: {
// //     key: "AIzaSyACbBFnoaG5EVR7-IDGn8lsiTtPHxWQWB4",
// //     libraries: "places", // This is required if you use the Autocomplete plugin
// //   },

// //   installComponents: true,
// // });
// // // Vue.forceUpdate()
// // Vue.config.productionTip = false;
// // Vue.use(CarouselPlugin);

// const configOptions = {
//   apiKey: "AIzaSyCjAO25m5q3tcutqboWO0RqAhZ-cl-XQvU",
//   authDomain: "eifoany.firebaseapp.com",
//   databaseURL: "https://eifoany.firebaseio.com",
//   projectId: "eifoany",
//   storageBucket: "eifoany.appspot.com",
//   messagingSenderId: "461273703020",
//   appId: "1:461273703020:web:90df54282f9f4ed7656e49",
//   measurementId: "G-XMXNG8GCP4",
// };

// firebase.initializeApp(configOptions);
// app.mount("#app");

// // new Vue({
// //   router,
// //   store,
// //   rtl: true,
// //   render: (h) => h(App),
// // }).$mount("#app");
